import React from "react";
import { Button } from "semantic-ui-react";

import withRoleCheck from "components/hocs/withRoleCheck";
import ACL_RELATIONSHIPS from "acl-relationships";

const AssignAgentsActionButton = withRoleCheck(Button, [
  ACL_RELATIONSHIPS.twilioPhoneNumber.assignAgents,
]);

/**
 * Action buttons for Twilio Phone Numbers table bulk actions.
 *
 * @param {Object} props - Component props
 * @param {Array} props.selectedIds - Array of selected phone number IDs
 * @param {Array} props.selectedData - Array of selected phone number data objects
 * @param {Function} props.handleAssignAgents - Handler to open assign agents modal
 * @returns {JSX.Element} Action buttons component
 */
export function TwilioPhoneNumbersTableActionButtons({
  selectedIds = [],
  selectedData = [],
  handleAssignAgents,
}) {
  const disabled = selectedIds.length === 0;

  return (
    <AssignAgentsActionButton
      size="mini"
      onClick={() => handleAssignAgents(selectedIds)}
      content="Assign Agents"
      disabled={disabled}
    />
  );
}
